import React, { Component } from 'react';
import style from '../share/pageList.module.css';
import TemplateV2 from '../../components/TemplateV2';
import * as utils from '../../Utils.js';
import BookingInfoV2 from '../../components/bookinginfov2/bookinginfov2';
import BackDropLoading from '../../components/BackDropLoading.js';



class BookingDetails extends Component {
    constructor(props) {
        //alert("Hotel");
        super(props);
        this.state = {
            infoData: null,
            resultStatus: "none",
            loading: true,
        };
    }
    componentDidMount() {
        this.props.appState.checkUser(this.props.appState);
        this.loadBookingData();
    }

    loadBookingData = () => {

        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/corp/bookinginfov2foremail";
        let data = {};
        let id = this.props.match.params.id;
        data.bookingId = id;

        utils.callPost(url, token, data, this.loadBookingDataCallBack);

        this.setState({
            resultStatus: "loading",
            loading: true
        });
    }
    loadBookingDataCallBack = (data) => {

        console.log(data);
        this.setState({
            infoData: data.Data,
            resultStatus: "none",
            showValidate: true,
            loading: false
        });
    }



    render() {
        //console.log(this.props);
        //alert(this.props.match.params.id);
        let id = this.props.match.params.id;



        return (
            <TemplateV2 appState={this.props.appState} site={this.props.site} page={"statementlist"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />
                    <BookingInfoV2 appState={this.props.appState} bookingId={id} infoData={this.state.infoData} />
                </div>
            </TemplateV2>
        );
    }
}
export default BookingDetails;